import { memo } from "react"

type SvgProps = React.ComponentPropsWithoutRef<"svg">

export const MathIcon = memo(({ className, ...props }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 5h-7L8 19l-3-6H3m11 0l6 6m-6 0l6-6"
      />
    </svg>
  )
})

MathIcon.displayName = "MathIcon"

